// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_fnQAL","input-number":"input-number_yr0xl"};